'use client';

import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';

/**
 * Custom 404 page to handle missing routes gracefully.
 * This helps reduce the "noise" in logs by providing a clear UI for 404s.
 */
export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 text-center">
      <h1 className="text-6xl font-bold font-headline text-primary mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-6">Oops! Page Not Found</h2>
      <p className="text-muted-foreground max-w-md mb-8">
        The page you're looking for doesn't exist or has been moved. 
        Don't worry, even the best explorers get lost sometimes!
      </p>
      <Button asChild variant="accent" size="lg" className="rounded-full">
        <Link href="/">
          <Home className="w-4 h-4 mr-2" />
          Back to Home
        </Link>
      </Button>
    </div>
  );
}
